import classNames from 'classnames';
import React from 'react';

import { markdownToHTML } from '../utils/string';

import './MarkdownText.css';

const Block = (props) => (<div {...props}/>);
const Inline = (props) => (<span {...props}/>);

export default ({ text, condensed, inlineOnly }) => {
  const Component = inlineOnly ? Inline : Block;
  return (
    <Component
      className={classNames('Markdown', {
        'Markdown--condensed': condensed,
      })}
      dangerouslySetInnerHTML={{
        __html: markdownToHTML(text.trim(), inlineOnly),
      }}
    />
  );
};


// WEBPACK FOOTER //
// ./src/components/MarkdownText.js